export const isNullOrWhitespace = (stringValue) => {
    return stringValue === undefined || stringValue === null || stringValue === '' || stringValue.split(' ').join('') === ''
}